/** @jsx jsx */

import React, { useContext, useRef, useEffect } from 'react';
import { css as _css } from 'emotion';
import { css, jsx } from '@emotion/core';
import getTopics from 'services/apiHelpers/getTopics';
import TopicPanel from './TopicPanel';
import { interactionContext } from './interactionContext';
import { unlockInteraction } from 'services/unlockInteraction';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';
import { updateTopicPortalMedia } from './updateTopicPortalMedia';

const TopicPortalContainer = props => {
  const context = useContext(interactionContext);
  const {
    selectedTopics = [],
    hideTopicsThatIncludeATopicPortal = true,
  } = context?.props;
  //

  const { children } = props;

  const topics = getTopics();

  const displayedTopics = topics.filter((t: any, index: number) => {
    const topicIncludesPortal = getInteractionsInTopic(t).find(i => {
      return i?.meta?.subType === 'TopicPortal';
    });

    if (selectedTopics.length) {
      return (
        selectedTopics.includes(t?.props?.sId) || selectedTopics.includes(t.id)
      );
    }

    return (
      !(hideTopicsThatIncludeATopicPortal && topicIncludesPortal) &&
      t.props.hiddenFromPortal !== true
    );
  });

  window.dev() &&
    console.log(
      'portal will unlock when these topics ( updated to reference the sId ) are complete :',
      displayedTopics.map(t => {
        return `${t?.props?.sId} || ${t?.id} ${t?.props?.name}`;
      })
    );

  const { lockDown } = context.props;

  const itemsSeen = useRef(
    unlockInteraction(context.id, (displayedTopics as any).length)
  );

  const { addMedia, removeMedia } = updateTopicPortalMedia(topics, context.id);

  const updateTopicComplete = id => {
    // if (lockDown === 0) {
    //   return;
    // }

    itemsSeen.current(id);
  };

  useEffect(() => {
    if (!window.dev()) {
      return;
    }

    if (topics.length > children.length) {
      addMedia();
      return;
    }

    removeMedia();

    return () => {};
  }, [topics.length]);

  return (
    <div
      css={css`
        width: 100%;
      `}
    >
      <div
        css={css`
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          margin: 12px 0 12px 0;
        `}
      >
        {displayedTopics.map((t: any, index: number) => {
          const topicMedia = props.children.find(media => {
            return media?.props?.topicId === t.id;
          });

          return (
            <TopicPanel
              key={t.id}
              topic={t}
              updateTopicComplete={updateTopicComplete}
              displayedTopics={displayedTopics}
            >
              {topicMedia ? topicMedia.props.children : null}
            </TopicPanel>
          );
        })}
      </div>
    </div>
  );
};

export default TopicPortalContainer;
